module.exports = __webpack_public_path__ + "assets/img/lxwm-bottom.1cfd5587.png";